module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-sm-8"
  }, [_c('div', {
    staticClass: "card card-default widget animated"
  }, [_c('div', {
    staticClass: "card-heading"
  }, [_c('form', {
    on: {
      "submit": _vm.createMobileDevice
    }
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_c('h5', [_vm._v("Information")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('form-text', {
    ref: "name",
    attrs: {
      "styler": "font-size:35px",
      "label": "Name",
      "name": "name",
      "validation": "required"
    },
    model: {
      value: (_vm.mobileDevice.name),
      callback: function($$v) {
        _vm.$set(_vm.mobileDevice, "name", $$v)
      },
      expression: "mobileDevice.name"
    }
  }), _vm._v(" "), _c('form-text', {
    attrs: {
      "label": "MDM Device ID",
      "name": "mdm_device_id"
    },
    model: {
      value: (_vm.mobileDevice.mdm_device_id),
      callback: function($$v) {
        _vm.$set(_vm.mobileDevice, "mdm_device_id", $$v)
      },
      expression: "mobileDevice.mdm_device_id"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('v-select', {
    attrs: {
      "placeholder": "Assigned Users",
      "multiple": "",
      "options": _vm.users,
      "label": "name",
      "name": "users",
      "value": _vm.mobileDevice.props.users
    },
    on: {
      "update:value": function($event) {
        return _vm.$set(_vm.mobileDevice.props, "users", $event)
      }
    }
  })], 1)], 1), _vm._v(" "), _vm._m(0)])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-5"
  }, [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn btn-success btn-lg",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Create")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-32592547","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/Devices/MobileDevice/CreateMobileDevice.vue
// module id = 612
// module chunks = 1